import(/* webpackMode: "eager", webpackExports: ["StatusBadge"] */ "/app/dashboard/app/_components/StatusBadge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
